import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Hongkong extends Component {
	state={
		youshi:[
			{
				name:'教育质量及认可度高',
				content:'2004年7月11日教育部部长周济与香港教育 统筹局局长李国章在北京签署了《内地与香港关于相互承认高等教育学位证书的备忘录》，教育部即日起承认 香港多所院校颁发的大学本科以上文凭。国际化程度高是香港高等教育一大特点，' +
					'主要表现在高校国际化师 资、国际化生源和国际化的教学三方面。' +
					'香港与内地互认高等教育文凭。香港各大学不分种族、信仰、文化， 面向世界招聘优秀教师。',
			},
			{
				name:'就业率高',
				content:'香港大学毕业生的就业率达九成以上。在香港念书的学生毕业后会有更多留在香港就业的机会。香港特区 政府2008年9月推出新政：' +
					'凡向出入境事务处提出申请的应届非本地毕业生，在签证到期之后，一律可以申请 续签12个月，逗留两年后，还可以无条件延期逗留两年，加起来一共就是四年，' +
					'这就给内地学生在香港寻找工 作和实习的机会。在这段期间他们可以随意就业，其后提出的延长逗留期限申请，根据其他非本地毕业生申请 的相关政策，得到在港受聘的同样优惠政策。',
			},
			{
				name:'性价比高',
				content:'香港求学费用大约在每年14万~25万人民 币；其中学费约8万~16万，住宿费和生活费约每年6万~9万人民币。一般来说，在香港大多数硕士学位的取得只需要1年的时间，而其他国家的硕士一般都需要2-3年。',
			},
			{
				name:'多元化地区',
				content:'香港是一个不分种族、宗教和肤色的多元化地区，欢迎世界各地的人才汇集至此。',
			},
		],
		zhuanye:[
			{
				title:'金融专业',
				content:'作为亚洲的金融中心，香港的金融业非常发达，几乎所有的世界著名银行、投资机构和保险公司，都在香港设有常驻机构或分支机构。香港高校开设的金融类专业，在世界上都非常具有竞争力，学生选择学习金融类专业，可以增加进入世界知名企业工作的机会。<br><br>' +
					'	推荐院校：香港大学，香港中文大学，香港科技大学，香港城市大学，香港浸会大学，香港理工大学',
				img:require('../../static/images/hongkong03.jpg')
			},
			{
				title:'教育专业',
				content:'香港高校的教育类专业也受到不少内地学生青睐，如英语教育、对外汉语等。不过申请这两个专业的申请人最好要有教学相关的经历，例如教师、家教或者任职于民营的培训机构等，教学经历优于学历背景。<br><br>' +
					'推荐院校：香港大学，香港中文大学，香港科技大学，香港浸会大学',
				img:require('../../static/images/hongkong04.jpg')
			},
			{
				title:'传媒专业',
				content:'香港各大学的传媒学院，是中央电视台、凤凰卫视等知名媒体的后备基地。由于香港特有的语言环境，授课时一般老师都是粤语、英语夹杂，也有极少数老师是全粤语教学，这对于刚进入粤语环境的内地学生无疑是一大挑战。因此，申请人一旦下定决心申请香港的学校，' +
					'便可即刻开始练习粤语，以便去到香港能跟上学习的步伐。<br><br>\n' +
					'\n' +
					'推荐院校：香港大学，香港中文大学，香港城市大学，香港浸会大学',
				img:require('../../static/images/hongkong05.jpg')
			},
			{
				title:'会计专业',
				content:'特许公认会计师公会香港分会的一项调查显示，60%以上的会计从业人员去年加薪达10%左右，预料今年增幅还会持续上升。尽管现在香港的会计项目看似很亲民，但是越来越多的申请人已经注意到了这个专业，申请难度也会逐渐加大，如果有兴趣的同学们一定要早作规划！<br><br>' +
					'推荐院校：香港科技大学，香港城市大学，香港理工大学，香港浸会大学',
				img:require('../../static/images/hongkong06.jpg')
			},
			{
				title:'理工类专业',
				content:'当前有众多世界百强企业，如通用电气、杜邦、飞利浦、微软等等，这些企业更乐意招聘在香港学习理工类专业的硕士毕业生。在理工类专业中，又以电子电气工程、机械工程和计算机最为热门。理工类专业的招生比率在所有专业中算是最高的，自然也是较好申请的。<br><br>' +
					'推荐院校 ：香港大学，香港中文大学，香港城市大学，香港理工大学，香港科技大学',
				img:require('../../static/images/hongkong07.jpg')
			},
		]
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/hongkong01.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>中国香港简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								中国香港位于中国东南端，是发展日渐迅速的东亚地区的枢纽，地理条件优越。 <br/><br/>

								中国香港是一座国际化的大都市，也是一个金融经济中心；中西文化交汇的地区，推行先进的教育模式，理论与实践并重，有着更广阔的发展前景，事业上有更多的提升机会。<br/><br/>

								中国香港学校在国际高等教育研究机构QS最新公布的亚洲大学排名榜中，香港大学、香港科技大学、香港中文大学均晋身5强，分别位列第一、二及第四位。在师资国际化、学生国际化、校园国际化的评比中，香港的多数学校都获得了满分。
							</div>
							<img className={'img'} src={require('../../static/images/hongkong02.jpg')} alt=""/>
						</div>
						<div className={'title'}>
							<span>中国香港留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.youshi.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>中国香港留学热门专业</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.zhuanye.map((item,index)=>(
									<CardItem item={item} key={index}/>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Hongkong